import React from 'react';
import FieldError from './FieldError';

const TOPICS = ['מכירות', 'שירות לקוחות'] as const;

interface TopicSelectProps {
    value: string;
    error: string;
    onChange: (value: string) => void;
    onBlur: () => void;
}

const TopicSelect: React.FC<TopicSelectProps> = ({ value, error, onChange, onBlur }) => (
    <div className="cf-field">
        <div className="cf-select-wrapper">
            <select
                className={`cf-input cf-select${error ? ' cf-input--error' : ''}`}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
                id="cf-topic"
            >
                <option value="" disabled>נושא פניה</option>
                {TOPICS.map((topic) => (
                    <option key={topic} value={topic}>{topic}</option>
                ))}
            </select>
        </div>
        <FieldError message={error} />
    </div>
);

export default TopicSelect;
